import React from 'react';
import { Back_Arrow, formlogo, MasterCard } from '../../../assets/images/index';
import { Button } from 'react-bootstrap';
import {
  Checkbox,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Payment = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="payment_page_container">
        <div className="payment_page_details">
          <div className="payment_page_details_logo">
            <Button onClick={() => navigate(-1)}>
              <img src={Back_Arrow} alt="Back_Arrow" width="24" height="24" />
            </Button>
            <img src={formlogo} alt="formlogo" />
          </div>
          <div className="payment_page_details_content_heading">
            <h4>Upgrade plan ICE MAKE </h4>
            <h2>
              $349 <span>/ 1 year</span>
            </h2>
          </div>
          <div className="payment_page_details_content_data">
            <div className="payment_page_details_content_data-item">
              <div>
                <h4>1 year</h4>
                <h5>
                  Become PRO to get unlimited access to everything. <br />
                  Billed monthly
                </h5>
              </div>
              <h3>$349</h3>
            </div>

            <div className="payment_page_details_content_data-item">
              <h4>Subtotal</h4>
              <h3>$349</h3>
            </div>

            <div className="payment_page_details_content_data-item">
              <Button>Add promotion code</Button>
            </div>

            <div className="payment_page_details_content_data-item">
              <h4>Total due today</h4>
              <h3>$349</h3>
            </div>
          </div>
        </div>

        <div className="payment_page_form">
          <div className="payment_page_form_email">
            <TextField
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Email</InputAdornment>
                ),
              }}
            />
          </div>

          <div className="payment_page_form_card">
            <InputLabel htmlFor="number">Card information</InputLabel>
            <div className="payment_page_form_card-input">
              <TextField
                name="number"
                id="number"
                fullWidth
                placeholder="1234 1234 1234 1234 "
              />
              <div className="payment_page_form_card-cvcinput">
                <TextField fullWidth placeholder="MM / YY" />

                <TextField fullWidth placeholder="CVC" />
              </div>
            </div>
          </div>

          <div className="payment_page_form_name">
            <InputLabel htmlFor="name">Cardholder name</InputLabel>
            <TextField
              name="name"
              id="name"
              fullWidth
              placeholder="Full name on card"
            />
          </div>

          <div className="payment_page_form_name">
            <InputLabel htmlFor="country">Country or region</InputLabel>
            <Select
              fullWidth
              defaultValue="US"
              // value={age}
              // onChange={handleChange}
            >
              <MenuItem value={'US'}>US</MenuItem>
            </Select>
            {/* <TextField name="country" id="country"fullWidth placeholder="US" /> */}
          </div>

          <div className="payment_page_form_security">
            <div className="payment_page_form_security-checkbox">
              <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }} />
              <div>
                <h4>Securely save my inforamtion for 1-click checkout</h4>
                <h5>Pay faster on ICE MAKE and everywhere link is accepted.</h5>
              </div>
            </div>

            <div className="payment_page_form_security-mastercard">
              <img src={MasterCard} alt="MasterCard" width="24" />
              <h4>Mastercard •••• 9270</h4>
            </div>
          </div>

          <div className="purchasing_checkbox">
            <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 24 } }} />
            <h4>I’m purchasing as a business</h4>
          </div>

          <div className="subscribe_submit_btn">
            <Button onClick={() => navigate('/manageBilling')}>
              Subscribe
            </Button>
          </div>

          <div className="confirming_subscribe">
            <h4>
              By confirming your subscription, you allow ICE MAKE to charge you
              for future payments in accordance with their terms. You can always
              cancel your subscription. By placing your order, you agree to our{' '}
              <span>Terms of Service</span> and <span>Privacy Policy</span>.
            </h4>
          </div>
        </div>
      </section>
    </>
  );
};

export default Payment;
